import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, Grid, Badge, IconButton } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { ResponsivePie } from '@nivo/pie';
import BedIcon from '@mui/icons-material/Bed';
import { AttachMoney } from '@mui/icons-material';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import { getanalysis, units } from '../../components/Apis';
import Swal from 'sweetalert2';
import axios from "axios";
import { useTranslation } from 'react-i18next';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { useNavigate } from 'react-router';


const Dashboard = () => {
  const [analysis, setanalysis] = useState([]);
  const [Units, setUnits] = useState([]);

  // console.log("this is the analysis",analysis);
  const keys = analysis ? Object.keys(analysis) : [];
  const values = analysis ? Object.values(analysis) : [];
  console.log(" keys", values)
  const [loading, setLoading] = useState(true); // Add a loading state
  const { t, i18n } = useTranslation();
  const navigate=useNavigate();


  const [analysischarts, setanalysischarts] = useState([]);
  const fetchanalysis = async () => {
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we load the data.',
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await getanalysis();
      // console.log("objectfsdfsdfsd",response.monthly_revenue)
      setanalysis(response); // Store the response data
      setanalysischarts(response);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      Swal.close();
    }
  };
  const getUnits = async () => {
    Swal.fire({
      title: "Loading...",
      text: "Please wait while we load the data.",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await units();
      console.log(response);
      setUnits(Array.isArray(response) ? response : []); // Ensure response is an array
      setLoading(false);
      Swal.close();
    } catch (error) {
      console.error(error.message);
      setLoading(false);
      Swal.close();
      setUnits([]); // Set Units to an empty array in case of error
    }
  };
  useEffect(() => {
    fetchanalysis();
    getUnits();
  }, []);

  const data = [
    { name: t('Jan'), value: 0 || 0 },
    { name: t('Feb'), value: 0 || 0 },
    { name: 'Mar', value: values[2] || 0 },
    { name: 'Apr', value: values[3] || 0 },
    { name: 'May', value: 10 },
    { name: 'Jun', value: 12 },
    { name: 'Jul', value: 18 },
    { name: 'Aug', value: 20 },
  ];

  const totalBooking = analysis.total_units || 0;

  const circularData = [
    { label: (keys[0]) ? "Total Units" : '', value: analysis.total_units, color: '#27AE60' },
    { label: (keys[1]) ? "Pending Units" : '', value: analysis.pending_units, color: '#FFA150' },
    { label: (keys[2]) ? "Approved Units" : '', value: analysis.rejected_units, color: '#E74C3C' },
    // { label: 'Pending overview', value: 20, color: '#F39C12' },
  ];


  // const pieData = values.slice(1,values.length-1).map((item) => ({
  //   id: item.label,
  //   label: item.label,
  //   value: item || 0,
  //   color: item.color,
  // }));

  const pieData = circularData.map((item) => ({
    id: item.label,
    label: item.label,
    value: item.value || 0,
    color: item.color,
  }));


  // useEffect(() => {
  //   axios
  //     .get("https://app.baskeg.com/api/v1/owners/units-analysis", {
  //       headers: {
  //         Authorization:`Bearer ${localStorage.getItem('token')}`,
  //       },
  //     })
  //     .then((response) => {
  //       setanalysis(response.data.data); // Store the response data
  //     })
  //     .catch((err) => {
  //       console.error(err.message); // Handle error
  //     })
  // }, []);



  return (
    <div style={{backgroundColor:"var(--seco-col)",height:"100vh",paddingBottom:"5rem"}}>
      <Box sx={{ padding: 3, backgroundColor: 'var(--seco-col)', minHeight: '50vh', marginTop: { xs: '3rem', sm: '4rem', md: '0px' } }}>
        <Box sx={{display:"flex",justifyContent:"space-between",flexDirection:"row-reverse",gap:"1rem"}}>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ textAlign: i18n.language === 'ar' ? 'right' : 'left', fontSize: "24px", fontWeight: "700", marginBottom: "1rem" }}
          >
            Dashboard
          </Typography>

          <Box>
          <IconButton onClick={()=>{navigate("/notification")}}>
              {/* <Badge badgeContent={1} color="error">
                <NotificationsIcon />
              </Badge> */}
              <Badge badgeContent={0} color="error">
                <NotificationsIcon sx={{ color: "white", stroke: "gray", strokeWidth: 1 }}/>
              </Badge>
            </IconButton>
            <IconButton onClick={()=>{navigate("/Chat")}}>
              <Badge badgeContent={0} color="error">
              <ChatBubbleIcon sx={{ color: "white", stroke: "gray", strokeWidth: 1 }} />
              </Badge>
            </IconButton>
          </Box>
        </Box>
        <Grid container spacing={3}>
          {/* قسم الملخص */}
          <Grid item xs={12} md={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Card elevation={3} sx={{ borderRadius: 2 }}>
                  <CardContent sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: i18n.language === 'ar' ? 'right' : 'left',
                    flexDirection: i18n.language === 'ar' ? 'row-reverse' : 'row',
                    gap: '10px'
                  }}>
                    <div>
                      <Typography
                        variant="body1"
                        color="textSecondary"
                        sx={{ textAlign: i18n.language === 'ar' ? 'right' : 'left' }}
                      >
                        {t('Availableunits')}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          textAlign: i18n.language === 'ar' ? 'right' : 'left',
                          fontWeight: 800
                        }}
                      >
                        {i18n.language === 'ar' ? `${analysis.total_units} ${t('units')}` : `${t('units')} ${analysis.total_units}`}
                      </Typography>
                    </div>
                    <div
                      sx={{
                        backgroundColor: '#C47D601F',
                        borderRadius: '30%',
                        padding: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginRight: i18n.language === 'ar' ? 0 : '8px',
                        marginLeft: i18n.language === 'ar' ? '8px' : 0,
                      }}
                    >
                      <BedIcon sx={{ color: 'var(--pri-col)' }} />
                    </div>
                  </CardContent>
                </Card>
              </Grid>

              {/* <Grid item xs={12}>
              <Card elevation={3} sx={{ borderRadius: 2 }}>
                <CardContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                  <div>
                    <Typography variant="body1" color="textSecondary">
                      Currently Rented
                    </Typography>
                    <Typography variant="body1" style={{ textAlign: 'left', fontWeight: 800 }}>
                      50 units
                    </Typography>
                  </div>
                  <div
                    style={{
                      backgroundColor: '#60A9C61F',
                      borderRadius: '30%',
                      padding: '5px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: '8px',
                    }}
                  >
                    <DesignServicesIcon sx={{ color: '#60A9C6' }} />
                  </div>
                </CardContent>
              </Card>
            </Grid> */}

              <Grid item xs={12}>
                <Card elevation={3} sx={{ borderRadius: 2 }}>
                  <CardContent sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: i18n.language === 'ar' ? 'right' : 'left',
                    flexDirection: i18n.language === 'ar' ? 'row-reverse' : 'row',
                    gap: '16px'
                  }}>
                    <div>
                      <Typography
                        variant="body1"
                        color="textSecondary"
                        sx={{ textAlign: i18n.language === 'ar' ? 'right' : 'left' }}
                      >
                        {t('TotalRevenue')}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          textAlign: i18n.language === 'ar' ? 'right' : 'left',
                          fontWeight: 800
                        }}
                      >
                        {t('EGP')} {analysis.total_revenue}
                      </Typography>
                    </div>
                    <div
                      sx={{
                        backgroundColor: '#C47D601F',
                        borderRadius: '30%',
                        padding: '5px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <AttachMoney sx={{ color: 'var(--pri-col)' }} />
                    </div>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card elevation={3} sx={{ borderRadius: 2 }}>
                  <CardContent sx={{ textAlign: 'center', height: { xs: "200px", md: '300px' }, position: 'relative' }}>
                    <Typography variant="h6" gutterBottom>
                      {t('TotalBooking')}
                    </Typography>
                    <Box sx={{ flexDirection: { xs: 'row', md: 'column', }, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Box sx={{ height: '150px', position: 'relative', flex: '0 0 135px' }}>
                        <ResponsivePie
                          data={pieData}
                          margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                          innerRadius={0.75}
                          padAngle={3}
                          cornerRadius={3}
                          activeOuterRadiusOffset={8}
                          colors={{ datum: 'data.color' }}
                          borderWidth={1}
                          borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                          arcLabelsSkipAngle={10}
                          arcLabelsTextColor="#fff"
                          enableArcLinkLabels={false}
                          layers={[
                            'arcs',
                            'arcLabels',
                            'legends',
                            ({ centerX, centerY }) => (
                              <text
                                x={centerX}
                                y={centerY}
                                textAnchor="middle"
                                dominantBaseline="central"
                                style={{
                                  fontSize: '24px',
                                  fontWeight: 'bold',
                                  fill: '#333',
                                }}
                              >
                                {totalBooking}
                              </text>
                            ),
                          ]}
                        />
                      </Box>
                      <Box sx={{ marginTop: 2 }}>
                        {circularData.map((item, index) => (
                          <Box key={index} sx={{ marginBottom: '8px' }}>
                            <Typography
                              variant="body2"
                              sx={{
                                color: item.color,
                                fontSize: '14px',
                                textAlign: 'left',
                                direction: "ltr"
                              }}
                            >
                              {item.value} {item.label}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          {/* قسم الرسم البياني */}
          <Grid item xs={12} md={9} >
            <Card elevation={3} sx={{ borderRadius: 2, height: "65vh" }}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ textAlign: i18n.language === 'ar' ? 'right' : 'left' }}>
                  {t('TotalEarning')}
                </Typography>
                <ResponsiveContainer width="100%" height={400} sx={{ height: "100%" }}>
                  <LineChart
                    data={analysis.monthly_revenue}
                    // data={data}
                    margin={{ top: 10, right: i18n.language === 'ar' ? 0 : 10, left: i18n.language === 'ar' ? 10 : 0, bottom: 0 }}
                    mirror={i18n.language === 'ar'}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="name"
                      reversed={i18n.language === 'ar'}
                      dx={i18n.language === 'ar' ? 10 : 0}
                      orientation={i18n.language === 'ar' ? 'bottom' : 'bottom'}
                    />
                    <YAxis
                      orientation={i18n.language === 'ar' ? 'right' : 'left'}
                      dx={i18n.language === 'ar' ? 10 : 0}
                    />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke="#1976d2"
                      fill="#BBDEFB"
                      strokeWidth={2}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <TableContainer component={Paper} sx={{ marginTop: "2rem",paddingBottom:"5rem", paddingInline: "1rem" }}>
      <Typography
            variant="body1"
            color="textSecondary"
            sx={{ textAlign: i18n.language === 'ar' ? 'right' : 'left', fontSize: "16px", fontWeight: "600", marginBottom: "1rem" }}
          >
            Requests
          </Typography>
        <Table dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
          <TableHead style={{ backgroundColor: "#F2F4F7" }}>
            <TableRow>
              <TableCell align={i18n.language === 'ar' ? 'right' : 'left'}>
                {t('UnitName')}
              </TableCell>
              <TableCell align={i18n.language === 'ar' ? 'right' : 'left'}>
                {t('Created')}
              </TableCell>
              <TableCell align={i18n.language === 'ar' ? 'right' : 'left'}>
                {t('UnitStatus')}
              </TableCell>
              <TableCell align={i18n.language === 'ar' ? 'right' : 'left'}>
                {t('Number Of Bookings')}
              </TableCell>
              {/* <TableCell align={i18n.language === 'ar' ? 'right' : 'left'}>
                {t('reserve')}
              </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {Units.filter((record) => record.status !== "rejected")
              .map((record) => (
                <TableRow
                  key={record.id}
                  sx={{
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.04)",
                      cursor: "pointer",
                    },
                  }}
                >
                  <TableCell
                    align={i18n.language === 'ar' ? 'right' : 'left'}
                  >
                    {record.name}
                  </TableCell>
                  <TableCell
                    align={i18n.language === 'ar' ? 'right' : 'left'}
                  >
                    {record.created_at}
                  </TableCell>
                  <TableCell
                    align={i18n.language === 'ar' ? 'right' : 'left'}
                  >
                    {record.status === "pending" ? (
                      <button style={{
                        minWidth: "fit-content",
                        backgroundColor: "rgba(255, 161, 80, 0.12)",
                        color: "#FFA150",
                        border: "1px solid #FFA150",
                        borderRadius: "5px",
                        padding: "8px 12px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        whiteSpace: "nowrap",
                      }}>
                        {t('Active Now')}
                      </button>
                    ) : record.status === "approved" ? (
                      <button style={{
                        minWidth: "fit-content",
                        backgroundColor: "rgba(3, 152, 85, 0.12)",
                        color: "#039855",
                        border: "1px solid #039855",
                        borderRadius: "5px",
                        padding: "8px 12px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        whiteSpace: "nowrap",
                      }}>
                        {t('Live')}
                      </button>
                    ) : null}
                  </TableCell>
                  <TableCell
                    align={i18n.language === 'ar' ? 'right' : 'left'}
                  >
                    {record.number_of_bookings}
                  </TableCell>
                  {/* <TableCell
                    align={i18n.language === 'ar' ? 'right' : 'left'}
                  >
                    <span
                      style={{
                        display: 'inline-block',
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: record.reserve === 'Reserved' ? 'blue' : 'gray',
                        marginRight: '8px',
                      }}
                    ></span>
                    {record.reserve}
                  </TableCell> */}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Dashboard;
